export const OrderGroupState = {
	notActive: "notActive",
	active: "active",
	upcoming: "upcoming",
	all: "all",
};
